import CrmEnrichmentJobToggleContainer from "app/pages/sales-intelligence/modules/crm-enrichment/containers/CrmEnrichmentToggleContainer";
import useSfEnrichmentJobToggleMutation from "app/pages/sales-intelligence/modules/crm-enrichment/impl/salesforce/query/mutations/useSfEnrichmentJobToggleMutation";
import type { CrmEnrichmentJob } from "app/pages/sales-intelligence/modules/crm-enrichment/types/types";

type SfEnrichmentToggleProps = {
    readonly job: CrmEnrichmentJob;
    onRenameClick?: (job: CrmEnrichmentJob) => void;
    onDeleteClick?: (job: CrmEnrichmentJob) => void;
};

const SfEnrichmentJobToggle = ({ job, onDeleteClick, onRenameClick }: SfEnrichmentToggleProps) => {
    const { mutate: mutateToggle } = useSfEnrichmentJobToggleMutation();

    const handleToggle = (jobId: string, value: boolean) => {
        mutateToggle({ jobId, value });
    };

    return (
        <CrmEnrichmentJobToggleContainer
            job={job}
            onToggle={handleToggle}
            onRenameClick={onRenameClick}
            onDeleteClick={onDeleteClick}
        />
    );
};

export default SfEnrichmentJobToggle;
